import { Combobox, ComboboxOption } from "@/components/ui/combobox";
import { useIncomeCategories } from "@/hooks/useIncomeCategories";
import { useExpenseCategories } from "@/hooks/useExpenseCategories";
import { getLeafCategories } from "@/lib/utils/categoryFilters";

interface CategorySelectProps {
  type: 'income' | 'expense';
  value: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  filterBySaleOperation?: boolean;
  modal?: boolean;
}

export const CategorySelect = ({ type, value, onValueChange, disabled, filterBySaleOperation, modal = true }: CategorySelectProps) => {
  const { categories: incomeCategories, isLoading: isLoadingIncome } = useIncomeCategories();
  const { categories: expenseCategories, isLoading: isLoadingExpense } = useExpenseCategories();

  const allCategories = type === 'income' ? incomeCategories : expenseCategories;
  const isLoading = type === 'income' ? isLoadingIncome : isLoadingExpense;

  // Filtrar apenas categorias folha (sem filhos) - categorias pai não podem ser usadas em lançamentos
  let leafCategories = getLeafCategories(allCategories);

  // §I.135: grupo 5 (movimentações não-resultado/transferências) fora dos lançamentos
  leafCategories = leafCategories.filter(cat => !(cat as any).dre_structure?.code?.startsWith('5'));

  // Se for tipo receita e filterBySaleOperation for true, filtrar apenas categorias de operação de venda
  if (type === 'income' && filterBySaleOperation) {
    leafCategories = leafCategories.filter(cat => (cat as any).is_sale_operation === true);
  }

  const options: ComboboxOption[] = leafCategories.map(cat => ({
    value: cat.id,
    label: cat.category_name,
    description: cat.description,
  }));

  const emptyMessage = filterBySaleOperation
    ? "Nenhuma categoria de venda configurada. Acesse Financeiro → Categorias de Receita e marque as categorias como 'Operação de Venda'."
    : "Nenhuma categoria encontrada. Apenas categorias finais (sem subcategorias) podem ser selecionadas.";

  return (
    <Combobox
      options={options}
      value={value}
      onValueChange={onValueChange}
      placeholder={isLoading ? "Carregando..." : "Selecione a categoria"}
      searchPlaceholder="Buscar categoria..."
      emptyMessage={emptyMessage}
      disabled={disabled || isLoading}
      modal={modal}
    />
  );
};
